import { c as _c } from "react/compiler-runtime";
import { getServerSideFlagsProps } from 'growthbook/server';
import { FlagsPropsType } from 'growthbook/types';
import { FormInputSearch, FormSelect } from '@systemeio/ui';
import TabMenu from 'modules/courses/components/tab-menu';
import { removeStudent } from 'modules/courses/students/api/student-api';
import StudentContactTooltip from 'modules/courses/students/components/student-contact-tooltip';
import { StudentsLoco } from 'modules/courses/students/constants/students-loco';
import { useStudentCourses } from 'modules/courses/students/hooks/use-student-courses';
import { useStudents } from 'modules/courses/students/hooks/use-students';
import { CoursesDataInterface, StudentFilterInterface } from 'modules/courses/students/types/student-filter-interface';
import { StudentInterface } from 'modules/courses/students/types/student-interface';
import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import ProgressBar from 'shared/components/progress-bar';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps, getCombinedServerSideProps } from 'shared/utils/get-base-server-side-props';
const defaultFilters: StudentFilterInterface = {
  searchBy: '',
  course: undefined
};
const Student: NextPage<FlagsPropsType> = () => {
  const $ = _c(86);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters);
  let t0;
  if ($[0] !== filter || $[1] !== limit || $[2] !== pagination) {
    t0 = {
      limit,
      pagination,
      filter
    };
    $[0] = filter;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    students,
    counter,
    revalidateStudentsModule
  } = useStudents(t0);
  const {
    data: courses
  } = useStudentCourses();
  const [courseData, setCourseData] = useState();
  let t1;
  let t2;
  if ($[4] !== courses) {
    t1 = () => {
      if (courses) {
        const getCoursesData = () => courses.map(_temp);
        setCourseData(getCoursesData());
      }
    };
    t2 = [courses];
    $[4] = courses;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== revalidateStudentsModule) {
    t3 = async student => {
      await removeStudent(student.id);
      await revalidateStudentsModule(true);
    };
    $[7] = revalidateStudentsModule;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onRemoveStudent = t3;
  let t4;
  if ($[9] !== t) {
    t4 = t("global.name");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = {
      key: "name",
      header: t4,
      widthPercent: 25
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("global.email");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = student_0 => {
      const studentEmail = <div className="truncate"><LinkWithoutPrefetch className="primary-link w-full" href={`/courses/students/${student_0.id}`}>{student_0.email}</LinkWithoutPrefetch></div>;
      return <>{student_0.email ? student_0.contact ? <StudentContactTooltip contact={student_0.contact}>{studentEmail}</StudentContactTooltip> : <>{studentEmail}</> : <span>{t("global.hidden")}</span>}</>;
    };
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = {
      key: "email",
      header: t6,
      widthPercent: 25,
      onRender: t7
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("dashboard.students.progress");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = {
      key: "progress",
      header: t9,
      widthPercent: 25,
      onRender: _temp2
    };
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("dashboard.students.last_engagement_date");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== user?.dateFormat || $[27] !== user?.timeFormat || $[28] !== user?.timezone) {
    t12 = student_2 => <>{student_2.lastEngagementDate ? dateTimeFormat(student_2.lastEngagementDate, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      }) : ""}</>;
    $[26] = user?.dateFormat;
    $[27] = user?.timeFormat;
    $[28] = user?.timezone;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = {
      key: "lastEngagementDate",
      header: t11,
      widthPercent: 25,
      onRender: t12
    };
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t13 || $[35] !== t5 || $[36] !== t8) {
    t14 = [t5, t8, t10, t13];
    $[33] = t10;
    $[34] = t13;
    $[35] = t5;
    $[36] = t8;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const columns = t14;
  let t15;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <TabMenu />;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t) {
    t16 = t("dashboard.students.title_plural");
    $[39] = t;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== courseData || $[42] !== t) {
    t17 = {
      field: "course",
      onRender: (value, onChange) => <FormSelect key="students-course-filter" data={courseData} onChange={data => onChange(data)} value={value} placeholder={t("dashboard.students.select_course")} />
    };
    $[41] = courseData;
    $[42] = t;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t) {
    t18 = {
      field: "searchBy",
      onRender: (value_0, onChange_0) => <FormInputSearch placeholder={t("dashboard.students.search_by_email")} key="student-search-filter" onClear={() => onChange_0("")} value={value_0} onChange={e => onChange_0(e.target.value)} />
    };
    $[44] = t;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t17 || $[47] !== t18) {
    t19 = [t17, t18];
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== filter || $[50] !== setFilter) {
    t20 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[49] = filter;
    $[50] = setFilter;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== pagination || $[53] !== setPagination) {
    t21 = {
      pagination,
      setPagination
    };
    $[52] = pagination;
    $[53] = setPagination;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== limit || $[56] !== setLimit) {
    t22 = {
      limit,
      setLimit
    };
    $[55] = limit;
    $[56] = setLimit;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t19 || $[59] !== t20 || $[60] !== t21 || $[61] !== t22) {
    t23 = {
      filterable: t19,
      filterer: t20,
      paginator: t21,
      limiter: t22
    };
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== limit || $[64] !== setLimit) {
    t24 = {
      limit,
      setLimit
    };
    $[63] = limit;
    $[64] = setLimit;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== pagination || $[67] !== setPagination) {
    t25 = {
      pagination,
      setPagination
    };
    $[66] = pagination;
    $[67] = setPagination;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== t) {
    t26 = t("dashboard.students.confirm_modal");
    $[69] = t;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== onRemoveStudent) {
    t27 = {
      remove: {
        onChange: student_3 => onRemoveStudent(student_3)
      }
    };
    $[71] = onRemoveStudent;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== columns || $[74] !== students || $[75] !== t24 || $[76] !== t25 || $[77] !== t26 || $[78] !== t27) {
    t28 = <Table data={students} columns={columns} limiter={t24} paginator={t25} caption={t26} actions={t27} />;
    $[73] = columns;
    $[74] = students;
    $[75] = t24;
    $[76] = t25;
    $[77] = t26;
    $[78] = t27;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== counter || $[81] !== students || $[82] !== t16 || $[83] !== t23 || $[84] !== t28) {
    t29 = <>{t15}<ListingLayout data={students} counter={counter} title={t16} type="compact" filterData={t23}>{t28}</ListingLayout></>;
    $[80] = counter;
    $[81] = students;
    $[82] = t16;
    $[83] = t23;
    $[84] = t28;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  return t29;
};
export const getServerSideProps = getCombinedServerSideProps(getBaseServerSideProps(StudentsLoco, 'header.top_menu.students'), getServerSideFlagsProps());
export default Student;
function _temp(el) {
  return {
    id: el.id,
    caption: el.name
  };
}
function _temp2(student_1) {
  return <ProgressBar progress={student_1.progress} />;
}